module.exports = __webpack_public_path__ + "img/m4.604b743a.jpg";